import { HaulRateDto } from 'common/api/dto/rates.dto';
import currency from 'currency.js';
import { useMemo, useState } from 'react';
import { Column } from 'react-table';
import {
  RateFormProps,
  TableRateInput,
} from '../components/Sub-views/RatesView/Tabs/TableRateInput';
import {
  CenteredHeader,
  CenteredText,
} from '../components/Sub-views/RatesView/Tabs/styles';
import { createRateKey } from '../components/Sub-views/RatesView/utils/functions';

export type HaulRateTableRows = {
  range: string;
  rate: RateFormProps;
};

export const useHaulRatesTableData: {
  (
    rows: HaulRateDto[],
    isSubmitting: boolean,
  ): {
    columns: Column<HaulRateTableRows>[];
    data: HaulRateTableRows[];
    isEditing: boolean;
    setIsEditing: (isEditing: boolean) => void;
  };
} = (rows, isSubmitting) => {
  const [isEditing, setIsEditing] = useState(false);

  const columns: Column<HaulRateTableRows>[] = useMemo(
    () => [
      {
        Header: () => <CenteredHeader>Range</CenteredHeader>,
        accessor: 'range',
        width: '50%',
        Cell: ({ value }) => <CenteredText>{value}</CenteredText>,
      },
      {
        Header: () => <CenteredHeader>Haul Rate</CenteredHeader>,
        accessor: 'rate',
        width: '50%',
        Cell: ({ value }) => (
          <TableRateInput
            showInput={isEditing}
            value={value}
            isSubmitting={isSubmitting}
          />
        ),
      },
    ],
    [isEditing, isSubmitting],
  );

  const data: HaulRateTableRows[] = useMemo(
    () =>
      rows.map(({ id, range, rangeId, rate }) => ({
        range: `${range} miles`,
        rate: {
          formValueKey: createRateKey(rangeId, id),
          displayValue: rate ? currency(rate).format() : '$0',
        },
      })),
    [rows],
  );

  return {
    columns,
    data,
    isEditing,
    setIsEditing,
  };
};
